import GetWebMembersOperationByIdRequestModelBase from '../_generated/modelBases/get-web-members-operation-by-id-request-model-base';

export default class GetWebMembersOperationByIdRequestModel extends GetWebMembersOperationByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
